
const mutations = {
  setData: (state, payload) => {
    state.data = payload
  },
  setMessage: (state, payload) => {
    state.message = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/contributor/mutations.js